import { ucFirst, amount as formatAmount } from "../format";
import {
  getSymbol,
  getAge,
  formatNumberByThousands,
  formatFiat,
} from "./transactionFormatter";

export const getBitcoinMainInfo = (transaction) => {
  const { amount_transferred, hash, block, network } = transaction;

  const amountValue = {
    amount: amount_transferred
      ? `${formatAmount(amount_transferred.amount, amount_transferred.decimals)} ${amount_transferred.symbol}`
      : 0,
    usd_value: amount_transferred
      ? `$\u202F${Number(amount_transferred.usd_value).toFixed(2)}`
      : 0,
  };

  const details = [
    {
      id: 1,
      label: "Coin",
      value: `${ucFirst(network)} • ${getSymbol(network)}`,
    },
    {
      id: 2,
      label: "Time",
      value: block?.timestamp,
    },
    {
      id: 3,
      label: "Hash",
      value: hash,
      underline: false,
    },
  ];

  return {
    icon: network,
    title: `${ucFirst(network)} transaction`,
    subtitle: "",
    details,
    amountData: amountValue,
    copyValue: hash,
  };
};

export const getBitcoinOutputs = (details, result) => {
  const outputs = details?.outputs.map(({ value, address }) => {
    return {
      amount: value.amount / Math.pow(10, value.decimals),
      decimals: value.decimals,
      symbol: value.symbol,
      usd_value: value.usd_value,
      formattedFiat: `$\u202F${Number(value.usd_value).toFixed(2)}`,
      address,
    };
  });
  const inputs = details?.inputs.map(({ value, address }) => {
    return {
      amount: value.amount / Math.pow(10, value.decimals),
      decimals: value.decimals,
      symbol: value.symbol,
      usd_value: value.usd_value,
      formattedFiat: `$\u202F${Number(value.usd_value).toFixed(2)}`,
      address,
    };
  });
  return { ...result, inputs, outputs };
};

export const getBitcoinTableData = (transaction) => {
  const { block, details, fee, status } = transaction;
  const { inputs_count, outputs_count, size, weight } = details;
  const timestamp = block?.timestamp;
  const age = timestamp ? getAge(timestamp) : "";

  const tableItems = [
    {
      id: 1,
      label: "Block ID",
      value: {
        title: block?.number.toLocaleString() || "Unconfirmed transaction",
      },
    },
    {
      id: 2,
      label: "Age",
      value: { title: age },
    },
    {
      id: 3,
      label: "Inputs",
      value: { title: inputs_count },
    },
    {
      id: 4,
      label: "Outputs",
      value: { title: outputs_count },
    },
    {
      id: 5,
      label: "Status",
      value: {
        title: status?.confirmed ? "Confirmed" : "Unconfirmed",
        confirmationCount: formatNumberByThousands(status?.confirmations || 0),
        totalConfirmations: 6,
      },
    },
    {
      id: 8,
      label: "Size",
      value: {
        title: `${size} bytes`,
      },
    },
    {
      id: 9,
      label: "Weight",
      value: {
        title: `${weight.toLocaleString()}`,
      },
    },
  ];

  if (fee) {
    tableItems.push({
      id: 10,
      label: "Fee",
      value: {
        title: `${formatAmount(fee.amount, fee.decimals)} ${fee.symbol}`,
        subtitle: formatFiat(fee.usd_value),
      },
      comma: true,
    });
  }

  return tableItems.sort((a, b) => a.id - b.id);
};
